import { Header, FloatingWhatsApp } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { DesertCall } from "../components/DesertCall";
import { TourSection } from "../components/TourSection";
import { RouteMap } from "../components/RouteMap";
import { Itineraries } from "../components/Itineraries";
import { Gallery } from "../components/Gallery";
import { About } from "../components/About";
import { QuoteForm } from "../components/QuoteForm";
import { Contact, Footer } from "../components/Contact";
import { useLang } from "../i18n";

export default function Home() {
  const { t } = useLang();
  return (
    <div className="App bg-[#0B0A08] text-[#F7F4EE]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <DesertCall />
        <TourSection id="moto" data={t.moto} images={["/img/moto_r4.jpg", "/img/moto_r3.jpg", "/img/moto_r2.jpg"]} />
        <RouteMap />
        <TourSection id="fourx4" data={t.fourx4} images={["/img/real4.jpg", "/img/real3.jpg", "/img/real2.jpg"]} reverse />
        <Itineraries />
        <Gallery />
        <About />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
